import dayjs from 'dayjs';
import { GridCustomCellProps } from "@progress/kendo-react-grid";

const DateOnlyCell = (props: GridCustomCellProps) => {
  if (!props.field || props.rowType !== 'data') return null;
  const date = props.dataItem[props.field];
  return (
    <td {...props.tdProps}>
      {date ? dayjs.utc(date).tz("America/New_York").format("MM/DD/YYYY") : "N/A"}
    </td>
  );
}

export default DateOnlyCell;
